import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { LogoutButton } from './LogoutButton';
import { Brand } from '../components/Brand';

export const LOGIN_PATH = '/';
export const CHANGE_PASSWORD_PATH = '/cambiar-password';
export const ADMIN_HOME_PATH = '/admin';
export const MEMBER_HOME_PATH = '/mi-cuenta';
export const COACH_HOME_PATH = '/coach';
export const KIOSK_HOME_PATH = '/kiosco';

/**
 * Resolves the single safe destination for a session, per the design spec's
 * "Inicio y recuperación de sesión" rules: a pending mandatory password
 * change always wins over role (nothing else is reachable until it's done),
 * then each supported role gets its own home.
 */
export function homePathForUser(user) {
  if (!user) return LOGIN_PATH;
  if (user.mustChangePassword) return CHANGE_PASSWORD_PATH;
  if (user.role === 'admin') return ADMIN_HOME_PATH;
  if (user.role === 'coach') return COACH_HOME_PATH;
  if (user.role === 'user') return MEMBER_HOME_PATH;
  if (user.role === 'kiosk') return KIOSK_HOME_PATH;
  return null;
}

/**
 * Static "no panel for you yet" screen shared by `RoleHomeRedirect` and
 * `RoleRoute`: a role with no supported destination must never be bounced in
 * a redirect loop, it just needs a clear explanation — and a way out, since
 * there is no shell (and so no sidebar logout) for it.
 */
export function AccessUnavailable() {
  return (
    <main className="gym-entry">
      <div className="gym-entry__panel">
        <Brand tone="light" />
        <h1 className="gym-entry__title">Acceso no disponible</h1>
        <p className="gym-entry__lead">
          Tu cuenta todavía no tiene un panel asignado en HAMMER. Consultá con recepción.
        </p>
        <LogoutButton variant="light" />
      </div>
    </main>
  );
}

/**
 * Route element for `/`: whoever wires the router renders this instead of
 * the login form once `status === 'authenticated'`, so a valid session never
 * sees the login screen again (spec: "Una sesión ya válida redirige sin
 * mostrar brevemente el login").
 */
export function RoleHomeRedirect() {
  const { user } = useAuth();
  const target = homePathForUser(user);
  if (!target) return <AccessUnavailable />;
  return <Navigate to={target} replace />;
}
